module.exports = __webpack_public_path__ + "static/media/fellowship-5.6c033e07.jpg";